// PredictedJokerMatchCard

import React, {useEffect, useRef, useState} from "react";
import IconTooltip from "../../assets/images/eoro-2024/icon-tooltip.svg";
import moment from "moment-timezone";


import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Card from "react-bootstrap/Card";
import {Col, Row} from "react-bootstrap";
import {MATCH_STATES} from "../../Constants/Match";

const PredictedJokerMatchCard = (props) => {
    const {
        isMobile,
        match,
    } = props;

    // console.log("match >>>", match)

    const [show, setShow] = useState(false);
    const target = useRef(null);

    const [matchStatus, setMatchStatus] = useState('Upcoming');
    // console.log("matchStatus >>>", matchStatus)

    useEffect(() => {
        if (MATCH_STATES.UPCOMING.includes(match?.state)) {
            setMatchStatus('Upcoming');
        }
        if (MATCH_STATES.IN_PLAY.includes(match?.state)) {
            setMatchStatus('InPlay');
        }
        if (MATCH_STATES.FINISHED.includes(match?.state)) {
            setMatchStatus('Finished');
        }
    }, [match]);


    const popover = (value) => (
        <Popover id="popover-basic" className={""}>
            <Popover.Body>
                <div className={"d-flex flex-column gap-1 align-items-start justify-content-start"}>
                    <div className={"cabin fw-700 font-20"}>{value?.venue?.name}</div>
                    <div className={"text-nowrap cabin fw-700 font-16"}>
                        {value?.venue?.city}
                    </div>
                </div>
            </Popover.Body>
        </Popover>
    );

    const renderHeader = (match) => {
        return(
            <>
                <div
                    className={`d-flex flex-row justify-content-center align-items-center ${isMobile ? "gap-1":"gap-2"}`}>
                    <div className={`${isMobile ? "font-11":"font-12"}`}>
                        Your Predicted Score
                    </div>
                    <div className={`${isMobile?"font-13":"font-14"}`}>
                        {match?.local_team?.prediction}
                    </div>
                    <div className={`${isMobile?"font-13":"font-14"}`}>-</div>
                    <div className={`${isMobile?"font-13":"font-14"}`}>
                        {match?.visitor_team?.prediction}
                    </div>
                    <div className={`${isMobile?"font-13":"font-14"}`}>|</div>
                    <div className={`${isMobile ? "font-11":"font-12"}`}>Points Scored</div>
                    <div>:</div>
                    <div className={`${isMobile?"font-13":"font-14"}`}>{match?.user_points_scored}</div>
                </div>
            </>
        )
    }

    const renderLocalTeam = (value) => {
        return (
            <>
                <div className={"d-flex flex-row align-items-center w-100 h-100 justify-content-center"}>
                    <div className={"d-flex flex-column align-items-center w-100 justify-content-center"}>
                        {/*{*/}
                        {/*    !isMobile &&*/}
                        {/*    <>*/}
                        {/*        <div className={`fw-300 cabin text-light-black ${isMobile ? "font-14" : "font-18"}`}>*/}
                        {/*            Pts: {value?.local_team?.standing?.points}*/}
                        {/*        </div>*/}
                        {/*    </>*/}
                        {/*}*/}

                        <img
                            src={value?.local_team?.icon}
                            className=""
                            alt={value?.local_team?.name}
                            height={isMobile ? 50 : 70}
                            width={isMobile ? 50 : 70}
                        />
                        <div
                            className={`fw-300 cabin text-uppercase ${isMobile ? "font-14" : "font-18"}`}>{value?.local_team?.name}</div>
                        {
                            isMobile &&
                            <>
                                <div className={"d-flex flex-row align-items-center gap-2 w-100 justify-content-around"}>
                                    <div className={`fw-300 cabin text-light-black font-11`}>
                                        P: {value?.local_team?.standing?.played}
                                    </div>
                                    <div className={`fw-300 cabin text-light-black font-11`}>
                                        Pts: {value?.local_team?.standing?.points}
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </>
        )

    }
    const renderCenterContent = (value) => {
        return (
            <>
                <div className={"d-flex flex-column align-items-center w-100 justify-content-between h-100 pt-2"}>
                    <div className={"d-flex flex-column align-baseline "}>
                        {
                            matchStatus === 'Upcoming' &&
                            <>
                                <div
                                    className={`d-flex align-items-center fw-bold cabin  w-100 justify-content-center ${isMobile ? "font-18" : "font-30"}`}>
                                    {moment(value?.time_begin, "HH:mm:ss").format("HH:mm")}
                                </div>
                            </>
                        }
                        {
                            [...MATCH_STATES.IN_PLAY, ...MATCH_STATES.FINISHED].includes(match?.state) &&
                            <>
                                <div
                                    className={`mt-3 d-flex align-items-center fw-bold cabin  w-100 justify-content-center ${isMobile ? "font-22" : "font-35"}`}>
                                    {match?.total}
                                </div>
                            </>
                        }
                        {
                            matchStatus !== 'Upcoming' &&
                            <div className={`text-capitalize text-skins-light-medium-gray roboto text-center ${isMobile ? "font-13" : "font-16"} `}>
                                {match?.status} {matchStatus === 'InPlay' && match?.state !== MATCH_STATES.HT ? `'` : ''}
                            </div>
                        }
                        {
                            matchStatus === 'Upcoming' &&
                            <>
                                {
                                    value?.local_team?.prediction === null && value?.visitor_team?.prediction === null ?
                                        <>
                                            <div
                                                className={`border fw-700 cabin text-light-black text-nowrap d-flex flex-column justify-content-center ${isMobile ? "px-1" : "px-2 py-1"}`}>
                                                <div className={`${isMobile ? "font-7":"font-9"}`}>
                                                    Your Predicted Score
                                                </div>
                                                <div className={`fw-700 cabin text-light-black text-nowrap d-flex flex-row justify-content-center ${isMobile ? "font-16 gap-1" : "font-25 gap-2"}`}>
                                                    <div>-</div>

                                                </div>
                                            </div>
                                        </>
                                        :
                                        <>

                                            <div
                                                className={`border fw-700 cabin text-light-black text-nowrap d-flex flex-column justify-content-center ${isMobile ? "px-1" : "px-2 py-1"}`}>
                                                <div className={`${isMobile ? "font-7":"font-9"}`}>
                                                    Your Predicted Score
                                                </div>
                                                <div className={`fw-700 cabin text-light-black text-nowrap d-flex flex-row justify-content-center ${isMobile ? "font-16 gap-1" : "font-25 gap-2"}`}>
                                                    <div>
                                                        {value?.local_team?.prediction}
                                                    </div>
                                                    <div>-</div>
                                                    <div>
                                                        {value?.visitor_team?.prediction}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                }
                            </>
                        }

                    </div>
                    <div>
                        {
                            match?.venue &&
                            <>
                                <div
                                    className={`w-100 d-flex flex-row align-items-center justify-content-center gap-2 ${isMobile ? "pb-1":"pb-2"}`}>
                                    <div
                                        className={`fw-400 cabin text-uppercase mt-1 ${isMobile ? "font-9 text-center" : "font-12"}`}>{match?.venue?.city}</div>
                                    <OverlayTrigger
                                        // trigger="click"
                                        placement={isMobile ? "top" : "right"}
                                        trigger={['hover', 'focus']}
                                        overlay={popover(match)}
                                    >
                                        <div role={"button"} ref={target} onClick={() => setShow(!show)}>
                                            <img
                                                src={IconTooltip}
                                                className="img-fluid"
                                                alt="icon"
                                                height={isMobile ? 10 : 20}
                                                width={isMobile ? 10 : 20}
                                            />
                                        </div>
                                    </OverlayTrigger>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </>
        )
    }
    const renderVisitorTeam = (value) => {
        return (
            <>
                <div className={"d-flex flex-row align-items-center w-100 h-100 justify-content-center py-2"}>
                    <div className={"d-flex flex-column align-items-center w-100 h-100 justify-content-center"}>
                        {/*{*/}
                        {/*    !isMobile &&*/}
                        {/*    <>*/}
                        {/*        <div className={`fw-300 cabin text-light-black ${isMobile ? "font-14" : "font-18"}`}>*/}
                        {/*            Pts: {value?.visitor_team?.standing?.points}*/}
                        {/*        </div>*/}
                        {/*    </>*/}
                        {/*}*/}
                        <img
                            src={value?.visitor_team?.icon}
                            className=""
                            alt={value?.visitor_team?.name}
                            height={isMobile ? 50 : 70}
                            width={isMobile ? 50 : 70}
                        />
                        <div
                            className={`fw-300 cabin text-uppercase ${isMobile ? "font-14" : "font-18"}`}>{value?.visitor_team?.name}</div>
                        {
                            isMobile &&
                            <>
                                <div className={"d-flex flex-row align-items-center gap-2 w-100 justify-content-around"}>
                                    <div className={`fw-300 cabin text-light-black font-11`}>
                                        P: {value?.visitor_team?.standing?.played}
                                    </div>
                                    <div className={`fw-300 cabin text-light-black font-11`}>
                                        Pts: {value?.visitor_team?.standing?.points}
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div>

            </>
        )
    }

    const renderMobile = () => {
        return (
            <>
                <Card className={"bg-white rounded d-flex flex-column m-0 p-0 border-0 predict-card"}
                    // style={{height:"120px"}}
                >
                    {
                        matchStatus !== 'Upcoming' &&
                        <Card.Header
                            className={`d-flex w-100 justify-content-center align-items-center border-0 p-0 m-0 bg-transparent`}
                        >
                            <div
                                className={`text-uppercase w-fit px-4 py-1 border-top-0 fw-400 font-8 text-white text-center bg-skins-red rounded-bottom-4 border-top-0`}
                            >
                                {renderHeader(match)}
                            </div>
                        </Card.Header>
                    }

                    <Card.Body className={"py-0"}>
                        <Row>
                            <Col>
                                {renderLocalTeam(match)}
                            </Col>
                            <Col>
                                {renderCenterContent(match)}
                            </Col>
                            <Col>
                                {renderVisitorTeam(match)}
                            </Col>
                        </Row>
                    </Card.Body>
                    <Card.Footer
                        className={"d-flex align-items-center justify-content-center m-0 p-0 border-0 bg-transparent"}>
                        <div className={"border-bottom-colors w-75"}></div>
                    </Card.Footer>
                </Card>
            </>
        );
    }

    const renderDesktop = () => {
        return (
            <>
                <Card className={`bg-white rounded d-flex flex-column m-0 p-0 border-0 predict-card`}>
                    {
                        matchStatus !== 'Upcoming' &&
                        <Card.Header
                            className={`d-flex w-100 justify-content-center align-items-center border-0 p-0 m-0 bg-transparent`}
                        >
                            <div
                                className={`text-uppercase w-fit px-4 py-1 border-top-0 fw-400 text-white text-center bg-skins-red rounded-bottom-4 border-top-0`}
                            >
                                {renderHeader(match)}
                            </div>
                        </Card.Header>
                    }
                    <Card.Body className={"py-0"}>
                        <Row>
                            <Col>
                                {renderLocalTeam(match)}
                            </Col>
                            <Col className={"p-0"}>
                                {renderCenterContent(match)}
                            </Col>
                            <Col>
                                {renderVisitorTeam(match)}
                            </Col>
                        </Row>
                    </Card.Body>
                    <Card.Footer
                        className={"d-flex align-items-center justify-content-center m-0 p-0 border-0 bg-transparent"}>
                        <div className={"border-bottom-colors-laptop w-75"}></div>
                    </Card.Footer>
                </Card>

            </>
        );
    }
    const render = () => {
        return (
            <section>
                {isMobile ? renderMobile() : renderDesktop()}
            </section>
        );
    }

    return render();
}

export default PredictedJokerMatchCard;
